<div class="dashboard-container safe-area-inset-top">

  <!-- Welcome Header -->
  <div class="dashboard-header">
    <div class="greeting-row">
      <div class="greeting-left">
        <span class="greeting-text">Hola{{ currentUser ? ', ' + currentUser.name : '' }}</span>
        <span class="conn-indicator" [class.connected]="isWebSocketConnected">
          <span class="conn-dot-mini"></span>
          <span class="conn-label">{{ isWebSocketConnected ? 'En linea' : 'Sin conexion' }}</span>
        </span>
      </div>
      <div class="header-actions">
        <button class="theme-toggle-btn" (click)="onToggleTheme()" [attr.aria-label]="isDarkMode ? 'Modo claro' : 'Modo oscuro'">
          <svg *ngIf="!isDarkMode" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
          </svg>
          <svg *ngIf="isDarkMode" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="5"/>
            <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
            <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
          </svg>
        </button>
        <span class="badge-points" *ngIf="personalStats.pointsEarned > 0">
          {{ personalStats.pointsEarned }} pts
        </span>
      </div>
    </div>
  </div>

  <!-- Main content - centered -->
  <div class="dashboard-body">

    <!-- Categories centered -->
    <div class="categories-section">
      <h2 class="section-label">Que necesitas?</h2>
      <div class="categories-grid">
        <div
          *ngFor="let cat of categories; let i = index"
          class="category-item"
          [style.animation-delay]="(i * 0.08) + 's'"
          (click)="onCategoryClick(cat)"
        >
          <div class="category-circle" [style.background]="cat.gradient">
            <span class="category-icon">{{ cat.icon }}</span>
          </div>
          <span class="category-name">{{ cat.name }}</span>
        </div>
      </div>
    </div>

    <!-- Quick Stats Row -->
    <div class="stats-row">
      <div class="stat-chip" routerLink="/nearby-restaurants">
        <span class="stat-chip-value">{{ personalStats.placesVisited }}</span>
        <span class="stat-chip-label">Lugares</span>
      </div>
      <div class="stat-chip" routerLink="/order-request">
        <span class="stat-chip-value">{{ personalStats.ordersCount }}</span>
        <span class="stat-chip-label">Pedidos</span>
      </div>
      <div class="stat-chip">
        <span class="stat-chip-value">{{ personalStats.reviewsWritten }}</span>
        <span class="stat-chip-label">Resenas</span>
      </div>
    </div>

    <!-- QR Scan Button -->
    <button class="qr-scan-btn" (click)="openQrModal()">
      <div class="qr-btn-icon">
        <!-- Camera body -->
        <svg viewBox="0 0 40 40" width="40" height="40" fill="none">
          <!-- Camera shape -->
          <rect x="4" y="10" width="32" height="22" rx="4" stroke="#22C55E" stroke-width="2.2"/>
          <path d="M14 10V8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2" stroke="#22C55E" stroke-width="2.2"/>
          <!-- QR pattern inside lens -->
          <rect x="14" y="16" width="5" height="5" rx="0.5" fill="#22C55E"/>
          <rect x="21" y="16" width="5" height="5" rx="0.5" fill="#22C55E"/>
          <rect x="14" y="23" width="5" height="5" rx="0.5" fill="#22C55E"/>
          <rect x="22" y="24" width="3" height="3" rx="0.3" fill="#34D399"/>
          <!-- Flash dot -->
          <circle cx="30" cy="14" r="1.5" fill="#34D399"/>
        </svg>
      </div>
      <span class="qr-label">Escanear QR del local</span>
    </button>

    <!-- Notifications row -->
    <div class="notif-row" *ngIf="unreadMessagesCount > 0 || nearbyUsersCount > 0">
      <span class="conn-badge" *ngIf="unreadMessagesCount > 0" routerLink="/chat">
        {{ unreadMessagesCount }} mensaje{{ unreadMessagesCount > 1 ? 's' : '' }}
      </span>
      <span class="conn-badge nearby" *ngIf="nearbyUsersCount > 0">
        {{ nearbyUsersCount }} cerca
      </span>
    </div>

  </div>

  <!-- Recent Activity (only if has data, at bottom) -->
  <div class="activity-section" *ngIf="recentActivity.length > 0">
    <h2 class="section-label">Reciente</h2>
    <div class="activity-list">
      <div
        *ngFor="let activity of recentActivity"
        class="activity-row"
        (click)="onActivityClick(activity)"
      >
        <div class="activity-icon">{{ activity.icon }}</div>
        <div class="activity-info">
          <span class="activity-title">{{ activity.title }}</span>
          <span class="activity-desc">{{ activity.description }}</span>
        </div>
        <span class="activity-arrow">></span>
      </div>
    </div>
  </div>

</div>

<!-- QR Scanner Modal -->
<div class="qr-modal-overlay" *ngIf="showQrModal" (click)="closeQrModal()">
  <div class="qr-modal" (click)="$event.stopPropagation()">
    <div class="qr-modal-header">
      <h3>Escanear QR</h3>
      <button class="qr-modal-close" (click)="closeQrModal()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="22" height="22">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="qr-modal-body">
      <!-- No permission -->
      <div *ngIf="!qrHasPermission && !qrError" class="qr-state">
        <div class="qr-state-icon">📷</div>
        <p>Solicitando acceso a la camara...</p>
      </div>

      <!-- Error -->
      <div *ngIf="qrError" class="qr-state qr-error">
        <div class="qr-state-icon">⚠️</div>
        <p>{{ qrError }}</p>
        <button class="qr-retry-btn" (click)="qrError = null; requestCameraPermission()">Reintentar</button>
      </div>

      <!-- No devices -->
      <div *ngIf="qrHasPermission && !qrHasDevices && !qrError" class="qr-state">
        <div class="qr-state-icon">🚫</div>
        <p>No se detectaron camaras en este dispositivo.</p>
      </div>

      <!-- Scanner active -->
      <div *ngIf="qrHasPermission && qrHasDevices && !qrError" class="qr-scanner-wrapper">
        <zxing-scanner
          [device]="qrCurrentDevice"
          [formats]="qrAllowedFormats"
          (scanSuccess)="onQrScanSuccess($event)"
          (scanError)="onQrScanError($event)"
          (hasPermission)="onQrPermission($any($event))"
          (camerasFound)="onQrCamerasFound($event)"
          class="qr-scanner-view"
        ></zxing-scanner>
        <div class="qr-scanner-frame">
          <div class="qr-corner tl"></div>
          <div class="qr-corner tr"></div>
          <div class="qr-corner bl"></div>
          <div class="qr-corner br"></div>
        </div>
        <p class="qr-instruction" *ngIf="!qrProcessing">Apunta al codigo QR del local</p>
        <div class="qr-processing" *ngIf="qrProcessing">
          <div class="qr-spinner"></div>
          <p>Procesando...</p>
        </div>
      </div>
    </div>
  </div>
</div>
